<template>
  <div>
    <edit-table
      v-if="mode === 'edit'"
      ref="editTable"
      :table.sync="tableData"
    />
    <detail-list v-if="mode === 'detail'" :table="tableData" />
    <supplier-edit-list
      v-if="mode === 'supplier-edit'"
      ref="supplierEditTable"
      :table.sync="tableData"
      v-bind="$attrs"
      :upload-mode="uploadMode"
    />
    <supplier-detail-list
      v-if="mode === 'supplier-detail'"
      :table="tableData"
      :upload-mode="uploadMode"
    />
  </div>
</template>

<script>
// 组件
import EditTable from '@/components/common/OtherMaterialRequirements/EditTable'
import DetailList from '@/components/common/OtherMaterialRequirements/DetailList'
import SupplierEditList from '@/components/common/OtherMaterialRequirements/SupplierEditList'
import SupplierDetailList from '@/components/common/OtherMaterialRequirements/SupplierDetailList'
// 方法
import { cloneDeep } from 'lodash'

/**
 * @Description: 其他材料要求综合组件，包含编辑表格和内容展示两种模式，通过mode控制
 */
export default {
  name: 'OtherMaterialRequirements',

  components: { EditTable, DetailList, SupplierEditList, SupplierDetailList },

  props: {
    table: {
      type: Array,
      default: () => []
    },

    /**
     * 控制组件的展现形式
     * - edit：采购人端编辑模式
     * - detail: 采购人端查看详情模式
     * - supplier-edit: 供应商端编辑模式，即供应商响应材料要求编辑模式
     * - supplier-detail: 供应商端查看详情模式
     */
    mode: {
      type: String,
      default: 'edit'
    },

    uploadMode: {
      type: String,
      default: 'groupId'
    }
  },

  computed: {
    tableData: {
      get() {
        return cloneDeep(this.table || [])
      },
      set(val) {
        this.$emit('update:table', cloneDeep(val))
      }
    }
  },

  methods: {
    /**
     * 校验表格数据
     */
    validateTable() {
      return this.$refs.editTable.validateTable()
    },

    /**
     * 校验供应商响应表单数据
     */
    validateSupplierForm() {
      return this.$refs.supplierEditTable.validateForm()
    }
  }
}
</script>

<style lang="scss" scoped></style>
